// apps/public/src/services/tawkto.js

export function initTawkto() {
  const propertyId = process.env.TAWKTO_PROPERTY_ID;
  const widgetId = process.env.TAWKTO_WIDGET_ID;

  if (!propertyId || !widgetId || window.Tawk_API) return;

  window.Tawk_API = window.Tawk_API || {};
  window.Tawk_LoadStart = new Date();

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://embed.tawk.to/${propertyId}/${widgetId}`;
  script.charset = "UTF-8";
  script.setAttribute("crossorigin", "*");

  const firstScript = document.getElementsByTagName("script")[0];
  firstScript.parentNode.insertBefore(script, firstScript);
}

export function openTawktoChat() {
  if (window.Tawk_API?.maximize) {
    window.Tawk_API.maximize();
  }
}